import api, { setToken } from '../index';

export function getTelegramGroups(data) {
  return api.get('/user/telegram-groups', setToken(data.token));
}
